import React, {memo} from 'react'

import {getJobName} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'
import usePipelineDocumentTitle from '../../../../../../hooks/usePipelineDocumentTitle'
import NameSection from '../../NameSection/NameSection'

import useJobNameValidationError from './hooks/useJobNameValidationError'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

type Props = {
  jobId: string
}

function JobName({jobId}: Props) {
  const pipelineId = usePipelineId()
  const name = useAppSelector(state => getJobName(state, pipelineId, jobId))
  const dispatch = useAppDispatch()

  const {handlerJobNameValidation, jobNameErrorMessage} = useJobNameValidationError(name, jobId)

  usePipelineDocumentTitle(`Edit ${name}`)

  return (
    <NameSection
      name={name}
      aria-label={'Job Name'}
      error={jobNameErrorMessage}
      onNameChange={newName =>
        dispatch(
          pipelineDraft.actions.setJobName({
            pipelineId,
            value: newName,
            savedValue: jobId,
          }),
        )
      }
      onBlur={handlerJobNameValidation}
      onConfirmClick={handlerJobNameValidation}
    />
  )
}

export default memo<Props>(JobName)
